import * as React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import Layout from "@components/Layout"
import { graphql } from "gatsby"

import Hero from "@modules/ContactUsPage/Hero"
import ContactForm from "@modules/ContactUsPage/ContactForm"
const ContactUsPage = ({ pageContext }) => {
  const { t, i18n } = useTranslation()

  if (i18n.language !== pageContext.language) {
    i18n.changeLanguage(pageContext.language)
  }
  return (
    <Layout pageContext={pageContext} theme="white-bg">
      <ContactForm />
      <Hero theme="white-bg" />
    </Layout>
  )
}

export default ContactUsPage

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
